import {ALIAS, LOADING_ALIAS,SELECTED_ALIAS} from './../types';
import {AppEnv} from '../../../components/env';
import axios from 'axios';
import Functions from '../../../components/Global/Functions';

const apiUrl = AppEnv.api;

export function setLoading(data) {
    return {
        type: LOADING_ALIAS,
        payload: data
    };
}

export function createAlias(token, fd) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'alias/create', fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchAlias(token));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchAlias(token));
        });
    };
}

export function fetchAlias(token) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'alias/get', {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            dispatch(fetchAliasSuccess(response.data));
        }).catch(error => {
            dispatch(fetchAliasFailed());
        });
    };
}

export function updateAlias(token, fd, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'alias/get/' + id, fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            dispatch(fetchAlias(token));
        }).catch(error => {
            // dispatch(fetchAliasFailed());
        });
    };
}

export function deleteAlias(token, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'alias/delete/' + id, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchAlias(token));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchAlias(token));
        });
    };
}

export function fetchAliasSuccess(response) {
    return {
        type: ALIAS,
        payload: response
    };
}

export function fetchAliasFailed() {
    Functions.alertFail();
    return {
        type: ALIAS,
        payload: []
    };
}

export function setAlias(Alias) {
    return {
        type: SELECTED_ALIAS,
        payload: Alias
    };
}